import { DomainBidderSchemaDTO } from 'features/globalSetup/api/types/domainBidderDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const DOMAIN_BIDDER_SCHEMA_FRAGMENT: TypedDocumentNode<DomainBidderSchemaDTO> = gql`
  fragment DomainBidderSchemaFragment on DomainBidderSchema {
    label
    name
    required
    requiredOff
    tooltip
    type
  }
`
